export const FACTION_UNIT_SKINS = {
  AQUARS: 'unit_skins_aquars',
  BEASTMEN: 'unit_skins_beastmen',
  CELECTIALS: 'unit_skins_celectials',
  DARK_ELVES: 'unit_skins_dark_elves',
  DEMONS: 'unit_skins_demons',
  DOPPLERS: 'unit_skins_dopplers',
  DRAGONS: 'unit_skins_dragons',
  DWARVES: 'unit_skins_dwarves',
  ELEMENTALS: 'unit_skins_elementals',
  ELVES: 'unit_skins_elves',
  ENLIGHTENED: 'unit_skins_enlightened',
  ENTS: 'unit_skins_ents',
  FENIX: 'unit_skins_fenix',
  GIANTS: 'unit_skins_giants',
  GOBLINS: 'unit_skins_goblins',
  GREMLINS: 'unit_skins_gremlins',
  HUMANS: 'unit_skins_humans',
  INSECTOIDS: 'unit_skins_insectoids',
  LEPRECHAUNS: 'unit_skins_leprechauns',
  MUSHROOM_PEOPLE: 'unit_skins_mushroom_people',
  ORCS: 'unit_skins_orcs',
  RATMEN: 'unit_skins_ratmen',
  SPIRITS: 'unit_skins_spirits',
  SUCCUBES: 'unit_skins_succubes',
  TECHNODWARVES: 'unit_skins_technodwarves',
  UNDEAD: 'unit_skins_undead',
  VENTORY: 'unit_skins_ventory',
  WIZARDS: 'unit_skins_wizards',
}